"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var breakpoints = ['36em', '62em', '80em'];
var theme = {
  breakpoints: breakpoints,
  fonts: {
    normal: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", "Segoe UI", Helvetica, Arial, Roboto, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    mono: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'
  },
  fontSizes: ['11px', '13px', '15px', '17px', '18px', '21px', '22px', '24px', '26px', '30px', '32px', '42px', '46px', '50px', '62px', '70px'],
  fontWeights: {
    regular: 400,
    medium: 500
  },
  textStyles: {
    caps: {
      textTransform: 'uppercase',
      letterSpacing: 1.2
    }
  },
  opacity: ['0', '0.25', '0.5', '0.75', '1'],
  space: ['0', '4px', '8px', '12px', '16px', '24px', '32px', '48px', '64px', '96px'],
  lineHeights: ['15px', '16px', '18px', '20px', '21px', '24px', '26px', '27px', '28px', '31px', '32px', '33px', '36px', '38px', '42px', '52px', '57px', '60px', '69px'],
  radii: [0, '2px', '4px', '6px', '12px', '24px', '100%', '999em'],
  borderWidths: [0, '1px', '2px', '4px'],
  shadows: {
    none: 'none',
    small: '0 2px 4px #12161616',
    medium: '0 -2px 7px 0 #03161616, 0 2px 10px 0 #1A505050',
    large: '0 2px 25px #40161616',
    borders: {
      rambutan: {
        complete: '#F02D00 0px 0px 0px 1px inset'
      },
      durian: {
        complete: '#e8e8e8 0px 0px 0px 1px inset'
      },
      sonar: {
        complete: '#161616 0px 0px 0px 1px inset',
        completeLight: '0px 0px 4px 0px rgba(22,22,22,0.2)'
      },
      guijarro: {
        complete: '#848484 0px 0px 0px 1px inset'
      }
    }
  },
  colors: {
    text: {
      dark: '#161616',
      light: '#FFFFFF'
    },
    coco: '#FFFFFF',
    sonar: '#161616',
    rambutan: '#F02D00',
    quandog: '#00B2BD',
    copoazu: '#f2f2f2',
    durian: '#e8e8e8',
    langsat: '#d9d9d9',
    guama: '#B0B0B0',
    guijarro: '#848484',
    castana: '#505050',
    inuit: '#d9f4f5',
    kawai: '#FEF1EE',
    cebolla: '#fffbe7',
    arandanos: '#3b5998',
    manzana: '#52ab43',
    kiwano: '#ff6400',
    pitaya: '#fd608b',
    lactariusIndigo: '#257aa0',
    lichi: '#f85453',
    calabaza: '#ffd100',
    manosDeBuda: '#f2a82d',
    status: {
      success: '#52ab43',
      danger: '#f85453',
      warning: '#ffd100'
    },
    social: {
      facebook: '#1877f2',
      twitter: '#1da1f2',
      youtube: '#ff0000',
      instagram: '#c32aa3',
      pinterest: '#bd081c',
      linkedin: '#007bb5',
      google: '#4285f4',
      whatsapp: '#25d366'
    },
    ghosted: {
      sonar: {
        lighter: 'rgba(22,22,22,0.15)',
        light: 'rgba(22,22,22,0.4)',
        dark: 'rgba(22,22,22,0.64)'
      },
      copoazu: {
        lighter: 'f2f2f21A',
        light: '#f2f2f24d'
      },
      coco: {
        lighter: '#ffffff1A',
        light: '#ffffff4d'
      }
    },
    variants: {
      rambutan: {
        light: '#CA2600',
        dark: '#A11E00'
      },
      quandog: {
        dark: '#007076',
        light: '#008F98'
      },
      sonar: {
        light: '#e5e5e5'
      }
    }
  },
  mediaQueries: {
    mobile: "@media screen and (min-width: 320px) and (max-width: 575px)",
    tablet: "@media screen and (min-width: 576px) and (max-width: 991px)",
    desktop: "@media screen and (min-width: 992px) and (max-width: 1280px)",
    wideScreen: "@media screen and (min-width: 1281px) and (max-width: 1920px)"
  }
};
exports.theme = theme;
var _theme$breakpoints = theme.breakpoints;

var _theme$breakpoints2 = (0, _slicedToArray2.default)(_theme$breakpoints, 3);

theme.breakpoints.mobile = _theme$breakpoints2[0];
theme.breakpoints.tablet = _theme$breakpoints2[1];
theme.breakpoints.desktop = _theme$breakpoints2[2];
_theme$breakpoints;